import React from 'react';

const hiddenNumber = value => {
  return (
    <>
      {value.trim().substring(0, value.length - 2)}
      <span className="icon-weathermoon1" />
      <span className="icon-weathermoon1" />
    </>
  );
};

export default hiddenNumber;
